import type { GhostMutationScope } from '../core/interfaces/IGhostSyncService';

export interface BlockReconciliationEvent {
  readonly id: string;
  readonly flavour: string;
  readonly isLocal: boolean;
}

const PERSISTENT_GHOST_SOURCE_FLAVOURS = new Set([
  'affine:database',
  'affine:automation',
]);

/**
 * Only a local change to a persisted ghost source carries user intent.
 * Hydration, remote collaboration, discovery, and reconciler output remain
 * observation-only.
 */
export function classifyGhostMutationScope(
  event: BlockReconciliationEvent
): GhostMutationScope | null {
  if (!event.isLocal || !PERSISTENT_GHOST_SOURCE_FLAVOURS.has(event.flavour)) {
    return null;
  }

  // Database relations and outgoing automations both target database ghosts.
  // Incoming/trashed automation ghosts use the local database as their stored
  // source and must not be deleted merely because remote discovery is partial.
  return { sourceBlockId: event.id, ghostType: 'database' };
}
